import { createContext, useContext, useState } from "react";
import { detectLanguage } from "./detectLanguage.js";
import { defaultLang, translations } from "./translations.js";

const LanguageContext = createContext();
const SUPPORTED_LANGS = ["en", "cs"];

export function LanguageProvider({ children }) {
	const [language, setLanguage] = useState(() => detectLanguage(SUPPORTED_LANGS, defaultLang));

	const translation = (key) => translations[key]?.[language] ?? key;

	return (
		<LanguageContext.Provider value={{ language, setLanguage, translation }}>
			{children}
		</LanguageContext.Provider>
	);
}

export function useLanguage() {
	return useContext(LanguageContext);
}
